<template>
    <div class="mainpage">
        <div class="whitebox">
            <h1>Welcome to kinktest.org</h1>
            <h3>{{myEmail}}</h3>
            <div class="my_features">
                <router-link to="/starttest" class="icon_starttest click_icon" title="Start a new test"><span>Start a new test</span></router-link>
                <router-link to="/test_history" class="icon_testresults click_icon" title="Test results"><span>Test results</span></router-link>
                <a href="#" @click.prevent="logout" class="icon_logout click_icon" title="Log out"><span>Log out</span></a>
            </div>
        </div><!--whitebox end--->
    </div><!--mainpage end--->
</template>
<script>
    export default {
        name: "myaccount",
        computed: {
            myEmail() {
                if (this.$store.state.user)
                    return this.$store.state.user.email
                return '';
            }
        },
        methods: {
            logout() {
                this.$store.commit('logout');
                this.$router.push('/signin');
            }
        }
    }
</script>

<style scoped>
 .click_icon{
     position: relative;
 }
.click_icon span{
    position: absolute;
    bottom: -25px;
    width: 200px;
    left: -50px;
    margin: 0 auto;
    text-align: center;
}
 @media screen and (min-width:769px){
     .click_icon span{display: none}
    }
</style>
